import { createAction } from "redux-actions";

export const addArticle = createAction("ADD_ARTICLE");
export const editArticle = createAction("EDIT_ARTICLE");
export const deleteArticle = createAction("DELETE_ARTICLE");



// WEBPACK FOOTER //
// ./src/actions/articles.js